import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";



// core components
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
// import CardContent from "components/Card/CardContent.jsx";
import Button from "components/CustomButtons/Button.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog/index";
import { connect } from "react-redux";
// import {store} from "../../_store";
import { store } from "../../_store/store.js";
import { alertActions, commonActions } from "../../_actions/index.js";
import { commonService } from "../../_services/index.js";
import { appConstants } from "../../_constants/index.js";
// import {commonActions} from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";
import OutstandingSettlementsTable from "./OutstandingSettlementsTable"
import CardFooter from "components/Card/CardFooter.jsx";
import DownloadIcon from "@material-ui/icons/CloudDownload";

// import TokenOutstanding from "@material-ui/icons/Info";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { appHelpers } from "../../_helpers/index.js";
import OutstandingSettlementsPanel from "./OutstandingSettlementsPanel.jsx";

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);

class OutstandingSettlements extends Component {

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 10,
      name: "",
      airlines: "",
      airlineData: [],
      AirlineId: '-1',
      selectValue: " ",
      airports: [],
      airportCode: "-1",
      startDate: aMonthAgo,
      endDate: today,
      dataCount: 0,
      currentPage: 1,
      pageSize: 10,
      requestingOutstandingSettlements: true,
      outstandingSettlements: [],
      totalCount: 0,
      billablePassengerCount: "",
      pscPaymentSettled: "",
      pscPaymentDue: "",
      walletBalance: "",
      outstandingPSCPayment: 0,
      graphModal: false,
      // walletChartData: defaultWalletData,
      minimumThreshold: "",
      airlineName: "",
      outstandingBillablePSC: 0,
      flightNumbers: [],
      FlightNumber: "-1"
    };
  }

  componentDidMount() {
    const { user, dispatch } = this.props;
    let { startDate, endDate, pageSize } = this.state;

    const { airports } = store.getState();
    this.fetchAirlines();

    if (user.AppRole === appConstants.ROLES.AIRLINE) {
      let userObj = { ...user };
      let userAirline = { value: userObj.AirlineId, label: userObj.AirlineName };
      this.setState({ AirlineId: userAirline, airlineName: user.AirlineName });
      const payload = {
        From: 1,
        PageSize: pageSize,
        Parameter: {
          StartDate: startDate,
          EndDate: endDate,
          AirlineId: user.AirlineId
        }
      }

      this.searchOutstandingSettlements(1, payload);
    }
    else if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
      let userObj = { ...user };
      let userLocation = { value: userObj.AirportCode, label: userObj.Location };
      this.setState({ airportCode: userLocation });

      const payload = {
        From: 1,
        PageSize: pageSize,
        Parameter: {
          StartDate: startDate,
          EndDate: endDate,
          AirportCode: user.AirportCode,
        }
      }

      this.searchOutstandingSettlements(1, payload);
    } else if (user.Location) {
      let userObj = { ...user };
      let userLocation = { value: userObj.AirportCode, label: userObj.Location };
      this.setState({ airportCode: userLocation });

      const payload = {
        From: 1,
        PageSize: pageSize,
        Parameter: {
          StartDate: startDate,
          EndDate: endDate,
          AirportCode: user.AirportCode,
        }
      }

      this.searchOutstandingSettlements(1, payload);
    } else {
      this.searchOutstandingSettlements(1);
    }
    if (airports) {
      this.setState({ airports })
    } else {
      dispatch(commonActions.getAllAirports());
    }

  }

  // fetch airlines
  fetchAirlines = () => {
    let { airlines } = store.getState()
    const { dispatch } = this.props;

    if (airlines) {
      this.setState({ airlineData: airlines, dataCount: airlines.Count })
    } else {
      dispatch(commonActions.getAllAirlines());
    }
  }

  componentWillReceiveProps = (nextProps) => {
    const { regionalAirlines, regionalAirports} = nextProps;

    if (regionalAirlines) {
      let modifiedAirline = [...regionalAirlines];
      let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
      modifiedAirline.unshift(allAirlines);
      this.setState({ airlineData: modifiedAirline, dataCount: regionalAirlines.Count })
    }
    if (regionalAirports) {
      let modifiedAirport = [...regionalAirports];
      modifiedAirport.unshift({ Name: "All Airports", airportLocation: "-1" });
      this.setState({ airports: modifiedAirport })
    }
  }


  handleGraphModal = () => {
    this.fetchWalletMovementData();
  };

  handleCloseGraphModal = () => {
    this.setState({ graphModal: false });
  };

  handleSelectChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleReactSelectChange = (value, name) => {
    this.setState({ [name.name]: value });
    if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
      this.setState({ [name.name]: "-1" })
    }
    if (name.name === "AirlineId") {
      this.setState({ flightNumbers: [], FlightNumber: "-1" });
      this.fetchAirlineFlightNumbers(value.value);
    }
  };


  fetchAirlineFlightNumbers = (airlineId) => {
    const { dispatch } = this.props;
    dispatch(alertActions.startRequest());
    commonService.getAirlinesFlightNumbersRegional(airlineId)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response;
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          let modifiedFlights = [...response.Results];
          modifiedFlights.unshift({ FlightNumber: "All Flights" });
          this.setState({ flightNumbers: modifiedFlights });
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }
      });
  };

  handleDateChange = (date, target) => {
    let currState = this.state;
    currState[target] = date;
    this.setState(currState);
  };

  loadOutstandingSettlementsData = (pageNumber) => {
    this.searchOutstandingSettlements(pageNumber)
  }

  searchOutstandingSettlements = (pageNumber = 1, payload) => {
    let { AirlineId, startDate, endDate, pageSize, airportCode, FlightNumber } = this.state
    const { dispatch } = this.props;
    startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
    endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

    let from = (pageNumber - 1) * pageSize;

    if (!payload) {
      payload = {
        From: from,
        PageSize: pageSize,
        Parameter: {
          StartDate: startDate,
          EndDate: endDate,
        }
      }

      if (AirlineId !== '-1') {
        payload.Parameter.AirlineId = AirlineId.value;
      }
      if (airportCode !== '-1') {
        payload.Parameter.AirportCode = airportCode.value;
      }
      if (FlightNumber !== "-1") {
        payload.Parameter.FlightNumber = FlightNumber.value;
      }
    }

    dispatch(alertActions.startRequest())
    commonService.getOutstandingBillablePassengerReportRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest())
        let response = res.response
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          this.setState({
            currentPage: pageNumber,
            requestingOutstandingSettlements: false,
            outstandingSettlements: response.Results,
            totalCount: response.TotalCount,
          });

          // this.packageWalletData(response.Entity.)
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
          this.setState({ requestingOutstandingSettlements: false });
        }
      })
  }

  // fetchWalletMovementData = () => {
  //   let { AirlineId, startDate, endDate } = this.state
  //   const { dispatch } = this.props;
  //   // let selectedAirlineId = AirlineId;
  //   startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
  //   endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");


  //   let payload
  //   if (AirlineId !== '-1') {
  //     payload = {
  //       AirlineId: AirlineId.value,
  //       IntervalType: 0,
  //       StartDate: startDate,
  //       EndDate: endDate

  //     }
  //   }
  //   else {
  //     payload = {
  //       IntervalType: 0,
  //       StartDate: startDate,
  //       EndDate: endDate
  //     }
  //   }

  //   dispatch(alertActions.startRequest())
  //   commonService.getWalletMovementData(payload)
  //     .then((res) => {
  //       dispatch(alertActions.stopRequest())
  //       let response = res.response
  //       if (res.status === appConstants.SUCCESS_RESPONSE) {

  //         this.packageWalletData(response.Results);
  //       }
  //       else if (res.status === appConstants.ERROR_RESPONSE) {
  //         dispatch(alertActions.error(res.response));
  //         this.setState({ requestingOutstandingSettlements: false });
  //       }
  //     })
  // }

  // packageWalletData = (data) => {
  //   const { graphModal, startDate, endDate } = this.state
  //   const { walletChartData } = setWalletData(data, startDate, endDate);
  //   this.setState({ walletChartData })
  //   this.setState({ graphModal: !graphModal })
  // }

  downloadOutstandingBillablePassengerReport = (e, DownloadType) => {
    e.preventDefault();
    const { AirlineId, startDate, endDate, airportCode, FlightNumber } = this.state
    const { dispatch } = this.props;

    let StartDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
    let EndDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

    let Parameter = {
      StartDate: StartDate,
      EndDate: EndDate,
      DownloadType: DownloadType
    };

    if (airportCode !== "-1") {
      Parameter.AirportCode = airportCode.value;
    }
    if (AirlineId !== "-1") {
      Parameter.AirlineId = AirlineId.value;
    }
    if (FlightNumber !== "-1") {
      Parameter.FlightNumber = FlightNumber.value;
    }

    let payload = { Parameter };

    dispatch(alertActions.startRequest());
    commonService.downloadOutstandingBillablePassengerReportRegional(payload)
      .then((res) => {
        dispatch(alertActions.stopRequest());
        let response = res.response
        if (res.status === appConstants.SUCCESS_RESPONSE) {
          dispatch(alertActions.success(response.Message));
          const isBase64 = !!response.base64File;
          const fileData = response.base64File || response; // filestream is in response directly
          const mimeType = appHelpers.getBinMimeTypeFromType(Parameter.DownloadType);
          console.log(mimeType, "mimeType");
  
          appHelpers.downloadFileV2(fileData, "Outstanding Billable Passenger Report", isBase64, mimeType);
          // if (response.DownloadUrl !== null) {
          //   appHelpers.downloadFile(response.DownloadUrl, "Outstanding Billable Passenger Report");
          // } else {
          //   dispatch(alertActions.error(response.Message));
          // }
        }
        else if (res.status === appConstants.ERROR_RESPONSE) {
          dispatch(alertActions.error(res.response));
        }

      })
  }

  render() {
    const { classes, requesting, user } = this.props;
    const { airlineData, AirlineId, startDate, endDate,
      requestingOutstandingSettlements, totalCount, outstandingSettlements,
      currentPage, pageSize, airports, airportCode, flightNumbers, FlightNumber    } = this.state;

    if (requestingOutstandingSettlements)
      return (
        <CircularProgress />
      );
    return (
      <div>

        {/* <Modal
          title={"Wallet Balance"}
          content={
            <WalletChart chartData={walletChartData} />

          }
          modalStatus={graphModal}
          handleClose={this.handleCloseGraphModal}
          // modalActionLabel={'Download'}
          // handleModalAction={this.downloadManifestPassenger}
          modalStyle={customModalStyle}
        /> */}

        {/*<LinearProgress variant="determinate" value={this.state.completed} />*/}
        <GridContainer>
          <OutstandingSettlementsPanel
            AirlineId={(this.props.user.AppRole === appConstants.ROLES.AIRLINE ? AirlineId : AirlineId.value)}
            airports={airports}
            airportCode={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? airportCode : airportCode.value}
            user={this.props.user}
            // airline={airlineName}
            data={airlineData}
            selectChange={(e, name) => this.handleReactSelectChange(e, name)}
            startDate={startDate}
            endDate={endDate}
            startLabel='Start Date'
            endLabel='End Date'
            handleDateChange={this.handleDateChange}
            onSearch={this.loadOutstandingSettlementsData}
            flightNumbers={flightNumbers}
            FlightNumber={FlightNumber.value}

          />
        </GridContainer>

        {/* Table */}
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="regional">
                <h4 className={classes.cardTitleWhite}>Outstanding Settlements Report</h4>
                <p className={classes.cardCategoryWhite}>
                  Outstanding Settlements Record for Airlines
                </p>
              </CardHeader>
              <CardBody>
                {!requestingOutstandingSettlements && totalCount !== 0 &&

                  <OutstandingSettlementsTable
                    outstandingSettlementsData={outstandingSettlements}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    fetchOutstandingSettlements={this.searchOutstandingSettlements}
                    totalCount={totalCount}
                  />
                }

                {!requestingOutstandingSettlements && totalCount === 0 &&
                  <EmptyRecord message={'No outstanding settlement record'} />
                }
              </CardBody>
              {!requestingOutstandingSettlements && totalCount !== 0 &&
                <CardFooter chart>
                  <div>
                    <Button type="button" color="info" onClick={(event) => this.downloadOutstandingBillablePassengerReport(event, appConstants.PDF_DOWNLOAD_TYPE)} disabled={requesting}>
                      <DownloadIcon />
                      Download PDF
                        </Button>
                    <Button type="button" color="regional" onClick={(event) => this.downloadOutstandingBillablePassengerReport(event, appConstants.EXCEL_DOWNLOAD_TYPE)} disabled={requesting}>
                      <DownloadIcon />
                      Download EXCEL
                        </Button>
                  </div>
                </CardFooter>
              }
            </Card>
          </Grid>

        </Grid>


      </div >
    );
  }
}

function mapStateToProps(state) {
  const { alert, progress, regionalAirlines, user, regionalAirports, requesting } = state;
  return {
    alert,
    progress,
    regionalAirports,
    regionalAirlines,
    user,
    requesting
  };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(OutstandingSettlements)));



// WEBPACK FOOTER //
// ./src/Regional-Views/OutstandingSettlement/Index.jsx